import {DirectiveOptions} from 'vue';

const replaceHandler = (event: KeyboardEvent) => {
  const $target = event.target as HTMLInputElement;
  $target.value = $target.value.replace(/[^0-9a-zA-Z]/g, '');
};

const inputOnlyIntegerAndEng: DirectiveOptions = {
  bind(el) {
    el.addEventListener('keyup', replaceHandler);
    el.addEventListener('keydown', replaceHandler);
  },
  unbind(el) {
    el.removeEventListener('keyup', replaceHandler);
    el.removeEventListener('keydown', replaceHandler);
  }
};
export default inputOnlyIntegerAndEng;
